/* eslint-disable */
import React from "react";
import { useState, useEffect } from "react";
import HeSelect from '../../components/HeSelect';
import tableau from "tableau-api";
// import "tableau-api/";
import HeAppWrapper from "../../components/HeAppWrapper";
import "./App.scss";

var he_global = {
    median_info: [],
    containerDiv: {},
    tableau_url: "",
    tableau_viz: {},
    tableau_workbook: {},
    tableau_dashboard: {},
    tableau_sheet: {}
};

function App() {
    const [state, setState] = useState({
        area:'city'
    });

    useEffect(() => {
        onAreaChange(state.area);
    }, [state.area]);

    useEffect(() => {
        initializeViz();
    }, []);

    return (
        <HeAppWrapper className="app-santa-fe-tool">
            <div id="aboveViz" style={{ backgroundColor: "#e6e6e6", paddingBottom: 10, paddingTop: 5 }} className="tableau-js-elements">
                <div style={{ float: "left", whiteSpace:'nowrap'}}>
                    <strong>Area: </strong>
                    <HeSelect 
                        defaultStyle={false}
                        customClass="area-dropdown"
                        data={[
                            {value:'city',label:'City of Santa Fe, NM'},
                            {value:'region',label:'Greater Santa Fe, NM'}
                        ]}
                        selected={'city'}
                        onChange={(selection)=>{
                            setState(prev=>({...prev,area:selection.value}));
                        }}
                    ></HeSelect>
                    {/* <select name="area" id="area" className="area-dropdown" onChange={onAreaChange}>
                        <option value="city" selected>
                            City of Santa Fe, NM
                        </option>
                        <option value="region">Greater Santa Fe, NM</option>
                    </select> */}
                </div>
                <div style={{ float: "right" }}>
                    <button name="clear-criteria" id="clear-criteria" className="tableau-btn" onClick={onClearCriteria}>
                        Clear Criteria
                    </button>
                    <button name="reset-criteria" id="reset-criteria" className="tableau-btn" onClick={onResetCriteria}>
                        Reset to Median
                    </button>
                </div>
            </div>
            <div id="vizContainer" style={{ width: "100%", height: 930 }}></div>
            <div id="belowViz" style={{ backgroundColor: "#e6e6e6", paddingBottom: 10, paddingTop: 5 }} className="tableau-js-elements">
                <div style={{ float: "left" }}></div>
                <div style={{ float: "right" }}>
                    <button name="export-image" id="export-image" className="tableau-btn" onClick={onExportImage}>
                        Export Map Image
                    </button>
                </div>
            </div>
        </HeAppWrapper>
    );
    function initializeViz() {
        he_global.containerDiv = document.getElementById("vizContainer");
        he_global.tableau_url = "https://tableau.headwaterseconomics.org/views/SantaFeRMRS/SantaFeFire";
        var vizOptions = {
            hideTabs: true,
            hideToolbar: true,
            onFirstInteractive: function() {
                setGlobalVariables();
            }
        };
    
        he_global.tableau_viz = new window.tableau.Viz(he_global.containerDiv, he_global.tableau_url, vizOptions);
    }
    
    function setGlobalVariables() {
        he_global.median_info = [
            {
                area: "city",
                fireBin1: "0.70",
                fireBin2: "3.09",
                fireBin3: "6.17",
                flameLength: "3",
                poverty: "10.4",
                disability: "12.0",
                over65: "19.55",
                under5: "4.40",
                language: "3"
            },
            {
                area: "region",
                fireBin1: "1.91",
                fireBin2: "5.03",
                fireBin3: "7.61",
                flameLength: "3",
                poverty: "8.35",
                disability: "12.2",
                over65: "18.95",
                under5: "4.3",
                language: "2.55"
            }
        ];
    
        he_global.tableau_workbook = he_global.tableau_viz.getWorkbook();
        he_global.tableau_dashboard = he_global.tableau_viz.getWorkbook().getActiveSheet();
        var objects = he_global.tableau_dashboard.getObjects();
        for (let i = 0; i < objects.length; i++) {
            //console.log("The object is a " + objects[i].getObjectType());
            if (objects[i].getObjectType() === "worksheet") {
                he_global.tableau_sheet = objects[i].getWorksheet();
            }
        }
    }
    function onAreaChange(val) {


        var selected_area_medians = getSelectedAreaMedians();
    
        if (Object.keys(selected_area_medians).length === 0) {
            console.log("no matching area was found");
        } else {
            displayAreaWithMedians(selected_area_medians);
            setAreaFilter();
        }
    }
    function getSelectedAreaMedians() {
        var selArea = state.area;
        var selected_area_medians = {};
    
        if (selArea === "") {
            console.log("the area can't be blank");
        } else {
            for (let i = 0; i < he_global.median_info.length; i++) {
                var median_info = he_global.median_info[i];
                if (selArea === median_info.area) {
                    selected_area_medians = median_info;
                    console.log("a matching area has been found");
                }
            }
        }
        return selected_area_medians;
    }
    function displayAreaWithMedians(selected_area_medians) {
        he_global.tableau_workbook.changeParameterValueAsync("Families in poverty percent criteria", selected_area_medians.poverty);
        he_global.tableau_workbook.changeParameterValueAsync("People with disability percent criteria", selected_area_medians.disability);
        he_global.tableau_workbook.changeParameterValueAsync("People over 65 percent criteria", selected_area_medians.over65);
        he_global.tableau_workbook.changeParameterValueAsync("People under 5 percent criteria", selected_area_medians.under5);
        he_global.tableau_workbook.changeParameterValueAsync("Speak English not well percent criteria", selected_area_medians.language);
        he_global.tableau_workbook.changeParameterValueAsync("fireBin1", selected_area_medians.fireBin1);
        he_global.tableau_workbook.changeParameterValueAsync("fireBin2", selected_area_medians.fireBin2);
        he_global.tableau_workbook.changeParameterValueAsync("fireBin3", selected_area_medians.fireBin3);
        he_global.tableau_workbook.changeParameterValueAsync("Average Flame Length Criteria", selected_area_medians.flameLength);
    }
    function onClearCriteria(e) {
        setCriteriaToZero();
    }
    function setCriteriaToZero() {
        he_global.tableau_workbook.changeParameterValueAsync("Families in poverty percent criteria", 0); //Families in poverty percent criteria
        he_global.tableau_workbook.changeParameterValueAsync("People with disability percent criteria", 0);
        he_global.tableau_workbook.changeParameterValueAsync("People under 5 percent criteria", 0);
        he_global.tableau_workbook.changeParameterValueAsync("People over 65 percent criteria", 0);
        he_global.tableau_workbook.changeParameterValueAsync("Speak English not well percent criteria", 0);
        he_global.tableau_workbook.changeParameterValueAsync("Average Flame Length Criteria", 0);
        he_global.tableau_workbook.changeParameterValueAsync("Likelihood of wildfire criteria", 1);
    
        he_global.tableau_workbook.getParametersAsync().then(checkvalues);
    }
    function checkvalues(parms) {
        console.log("parameters fetched!");
        var lowVal = { value: 2, formattedValue: ">= Medium Low" };
        he_global.tableau_workbook.changeParameterValueAsync("Likelihood of wildfire criteria", lowVal);
    }
    function onResetCriteria(e) {
        var selected_area_medians = getSelectedAreaMedians();
    
        if (Object.keys(selected_area_medians).length === 0) {
            console.log("no matching area was found");
        } else {
            displayAreaWithMedians(selected_area_medians);
        }
    }
    function setAreaFilter() {
        
        var selArea = state.area;
        if (selArea === "region") {
            he_global.tableau_sheet.clearFilterAsync("In City");
        } else {
            he_global.tableau_sheet.applyFilterAsync("In City", 1, window.tableau.FilterUpdateType.REPLACE);
        }
    }
    function onExportImage(e) {
        he_global.tableau_viz.showExportImageDialog();
    }
}

export default App;

